<template>
    <v-toolbar dark fixed id="header">
        <v-toolbar-title class="mr-4">
        <v-img :src="require('@/assets/abm-logo-transparent-white-text-500x110.png')" contain height="150" width="200" />
        </v-toolbar-title>
        <v-toolbar-title class="mr-4">        
                NeuroTraining {{portalVersion}}
        </v-toolbar-title>
        <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat dark v-if="$store.state.isUserLoggedIn">
                   {{$store.state.user.username}}
            </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">           
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
                 :to="{name: 'reviewAnswers'}">
                    Review Answers
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
                 :to="{name: 'viewChecklist'}">
                    Practicum Guidelines
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
               :to="{name: 'trainingCourse'}">
                    Go To Training
            </v-btn>
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
               :to="{name: 'contactUs'}">
                    Resources
            </v-btn>           
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn && $store.state.user.isTrainer"
            :to="{name: 'users', query:{search:this.$store.state.searchVal}}">
                Trainees
            </v-btn>                         
            <v-btn flat dark
                v-if="$store.state.isUserLoggedIn"
                @click="logout">
                    Log Out
            </v-btn>
            
        </v-toolbar-items>
        <v-menu class="hidden-md-and-up">
              <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-toolbar-items>
                    <v-list>
                         <v-list-tile flat dark
                            v-if="!$store.state.isUserLoggedIn"
                            :to="{name: 'login'}">
                                <v-list-tile-title>Log In</v-list-tile-title>
                         </v-list-tile>
                        <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                            @click="logout">
                                <v-list-tile-title>Log Out</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                             :to="{name: 'reviewAnswers'}">
                                <v-list-tile-title>Review Answers</v-list-tile-title>
                        </v-list-tile>
                         <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                            :to="{name: 'viewChecklist'}">
                                <v-list-tile-title>Practicum Guidelines</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn"
                        :to="{name: 'trainingCourse'}">
                                <v-list-tile-title>Go To Training</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile flat dark
                            v-if="$store.state.isUserLoggedIn && $store.state.user.isTrainer"
                            :to="{name: 'users'}">
                        <v-list-tile-title>Trainees</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile flat dark
                            v-if=" $store.state.isUserLoggedIn"
                        :to="{name: 'contactUs'}">
                                <v-list-tile-title>Resources</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-toolbar-items>
         </v-menu>
    </v-toolbar>

</template>

<script>


export default {
    methods: {
        logout(){
            this.$store.dispatch('setToken', null)
            this.$store.dispatch('setUser', null)
            this.$store.dispatch('logout')
            this.$router.push({
                name: 'login'
            })
        }
    }
}
</script>


<style scoped>
#header {
    background: #548FD0;
    background-color: #548FD0;
}
</style>
